import { Plugin } from '@nuxt/types'
import EventBusService from '@/services/EventBusService'

export const EventBus = new EventBusService()

declare module 'vue/types/vue' {
  interface Vue {
    $eventBus: EventBusService
  }
}

declare module '@nuxt/vue-app' {
  interface NuxtAppOptions {
    $eventBus: EventBusService
  }
}

const plugin: Plugin = (context, inject) => {
  inject('eventBus', EventBus)
}

export default plugin
